__turbopack_context__.v({
  "personItem": "style-module-scss-module__Gf9OzW__personItem",
  "personLabel": "style-module-scss-module__Gf9OzW__personLabel",
  "personPhoto": "style-module-scss-module__Gf9OzW__personPhoto",
});
